import React, { FC, useCallback } from 'react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import { oktaAuthConfig } from 'shared/config'
import { RestoreOriginalUriFunction } from '@okta/okta-react/bundles/types/OktaContext'
import { Outlet, useNavigate } from 'react-router-dom'

const oktaAuth = new OktaAuth(oktaAuthConfig)
export const OktaRouteProvider: FC = ({ children }) => {
  const navigate = useNavigate()
  const restoreOriginalUri = useCallback<RestoreOriginalUriFunction>(
    (_oktaAuth, originalUri) => {

      navigate(toRelativeUrl(originalUri || '/', window.location.origin))
    },
    [navigate]
  )
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Outlet />
    </Security>
  )
}
